import { useAppUserDetailsFromJwt } from 'common-react/auth/utils/hooks/useAppUserDetailsFromJwt/useAppUserDetailsFromJwt';
import { FullPageLoader } from 'components/BouncingLoader/FullPageLoader';
import { NoPermissionErrorState } from 'components/ErrorStates/NoPermissionErrorState/NoPermissionErrorState';
import { NoSitesErrorState } from 'components/ErrorStates/NoSitesErrorState/NoSitesErrorState';
import { SitesFetchingErrorState } from 'components/ErrorStates/NoSitesErrorState/SitesFetchingErrorState';
import { Permissions } from 'context/constants';
import { usePlutoApiQuery } from 'hooks/useQuery/plutoApi';
import { Optimisation } from 'pages/Optimisation/Optimisation';
import { GET_SITES } from 'pages/Optimisation/queries';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Site, SiteEdge } from 'types/site';

export const OptimisationWrapper = () => {
  const { company, site } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { permissions } = useAppUserDetailsFromJwt<Permissions>();

  const { data, loading, error } = usePlutoApiQuery<{
    sites: { edges: Array<SiteEdge> };
  }>(GET_SITES, {
    skip: !company,
    variables: {
      filter: {
        company: { id: { eq: company } },
      },
      paging: {
        first: 50,
      },
      sorting: [
        {
          field: 'name',
          direction: 'ASC',
        },
      ],
    },
  });

  useEffect(() => {
    if (!site && !!data?.sites?.edges?.length) {
      const firstSite = data.sites.edges[0].node.id;
      // use replace here to maintain browser history stack for the same path
      navigate(`${location.pathname}/${firstSite}`, { replace: true });
    }
  }, [site, data, navigate, location.pathname]);

  if (loading) {
    return <FullPageLoader />;
  }

  if (error) {
    return <SitesFetchingErrorState />;
  }

  if (!data?.sites?.edges?.length) {
    return <NoSitesErrorState />;
  }

  if (!permissions?.includes(Permissions.VIEW_OPTIMISATION)) {
    return <NoPermissionErrorState />;
  }

  const sites: Array<Site> = data?.sites?.edges?.map((x: any) => x.node);

  return <Optimisation sites={sites} />;
};
